import Disableable, { Disable, Enable } from '../../../../../../interface/Disableable.js';
import EL, { HTMLELEMENT } from '../../../../../EL/EL.js';
import FIELD from '../../../../../DOM/form/fieldset/field/FIELD.js';
import { makeAttrStruct } from '../../../../../../enums/ModelAttr.js';
import { makeStruct } from '../../../../../../enums/MODELS.js';
import { makeDataStruct } from '../../../../../../enums/ModelData.js';
// Model Structure
export const textareaAttr = makeAttrStruct([
    ['name'],
    ['maxLength', 255],
    ['placeholder', ''],
    ['required', false],
    ['rows', 20],
    ['cols', 20],
    ['wrap', 'soft']
]);
export const textareaData = makeDataStruct([
    ['text', '']
]);
export const textareaModel = makeStruct([
    ['attributes', textareaAttr],
    ['data', textareaData]
]);
// Simplified Model
export function textarea(name, maxLength, placeholder, required, rows, cols, wrap, text) {
    return {
        attributes: textareaAttr(name, maxLength, placeholder, required, rows, cols, wrap),
        data: textareaData(text)
    };
}
/** A TEXTAREA element */
export default class TEXTAREA extends FIELD {
    constructor(node, model) {
        super(node, HTMLELEMENT.TEXTAREA, model);
        if (!model.attributes.required) {
            this.removeAttribute('required');
        }
        this.implement(new Disableable(this));
    }
    getValue() {
        return this.el.value;
    }
    setValue(value) {
        this.el.value = value;
        return this;
    }
    checkValidity() {
        return this.el.checkValidity();
    }
    setCustomValidity(message) {
        this.el.setCustomValidity(message);
    }
}
export { Disable, Disableable, EL, Enable };
